<div class="saved-search-preset-form">

    <rpc-input class="saved-search-preset-input-wrap" [options]="nameControlOptions" [type]="'text'"
        [appearance]="'fill'" [label]="'SAVED_SEARCH_FORM.TITLES.SAVED_SEARCH_NAME'">
    </rpc-input>

    <rpc-select class="saved-search-preset-select-wrap" [appearance]="'fill'" [color]="'accent'"
        [readonly]="isMobile$ | async" [label]="'SAVED_SEARCH_FORM.TITLES.FOLDER'" [shouldTranslate]="false"
        [notSelectedText]="'SAVED_SEARCH_FORM.OPTIONS.NOT_SELECTED' | translate" [notSelectedAllowed]="true"
        [notSelectedVisible]="true" [controlOptions]="folderControlOptions" (closed)="onCloseCreateFolderControl()"
        (click)="onFolderMobileClick()">

        @if (isCreateFolderFormVisible) {
        <add-edit-folder-form class="saved-search-preset-folder-form" [name]="getNewFolderName()"
            (save)="onCreateFolderClicked($event)" (canceled)="onCloseCreateFolderControl()"
            [submitButtonText]="'SAVED_SEARCH_FORM.BUTTONS.CREATE'">
        </add-edit-folder-form>
        } @else {
        <ng-container *ngTemplateOutlet="createFolderButton">
        </ng-container>
        }

        <div class="rpc-divider rpc-divider--horizontal saved-search-preset-folder-divider">
        </div>

    </rpc-select>

    @if (isShowIncludePreviousMatchesCheckbox) {
    <div class="saved-search-preset-checkbox-wrap">

        <rpc-checkbox class="saved-search-preset-checkbox" [text]="'SAVED_SEARCH_FORM.TITLES.PREVIOUSLY_MATCHED'"
            [state]="includePreviousMatches" (changed)="onIncludePreviousMatchesChange($event)"
            [disabled]="isDisabledByTenantAgreementPolicy$ | async">
        </rpc-checkbox>

        <div class="saved-search-preset-checkbox-note">
            {{ 'SAVED_SEARCH_FORM.TITLES.NOTE' | translate }}.
        </div>

    </div>
    }

    <div class="saved-search-preset-checkbox-wrap">

        <rpc-checkbox class="saved-search-preset-toggle" [text]="'SAVED_SEARCH_FORM.TITLES.ENABLE_EMAIL'"
            [state]="enableEmail" [disabled]="isDisabledByTenantAgreementPolicy$ | async"
            (changed)="onEnableEmailChange($event)">
        </rpc-checkbox>

        <div class="saved-search-preset-checkbox-note">
            {{ 'SAVED_SEARCH_FORM.TITLES.ENABLE_EMAIL_SUBTITLE' | translate }}.
        </div>

    </div>

</div>

<ng-template #mobileFolderList>

    <div class="saved-search-option-wrap">

        <div class="saved-search-option-header">

            <div class="saved-search-option-header-title">
                {{'SAVED_SEARCH_FORM.TITLES.SELECT_FOLDER' | translate}}
            </div>

            <rpc-button class="saved-search-option-header-close" [iconName]="'cross'"
                [title]="'SAVED_SEARCH_FORM.TITLES.CLOSE'" (clicked)="onCloseFolderSelection()">
            </rpc-button>

            <ng-container *ngTemplateOutlet="createFolderButton">
            </ng-container>

            <div class="saved-search-option-header-divider">
            </div>

        </div>

        <div class="saved-search-option-body">

            <div class="saved-search-option-list">

                <rpc-button class="saved-search-option-folder" [class.saved-search-option-folder--default]="true"
                    [text]="'SAVED_SEARCH_FORM.OPTIONS.NOT_SELECTED'" (clicked)="onFolderSelected(folderNotSelectedId)">
                </rpc-button>

                @for (folder of folderControlOptions.options; track folder.value) {
                <rpc-button class="saved-search-option-folder" [text]="folder.text" [shouldTranslate]="false"
                    [iconName]="folder.iconName" (clicked)="onFolderSelected(folder.value)">
                </rpc-button>
                }

            </div>

        </div>

    </div>

</ng-template>

<ng-template #createFolderButton>

    <rpc-button class="saved-search-preset-folder" [text]="'SAVED_SEARCH_FORM.TITLES.NEW_FOLDER'" [iconName]="'add-new'"
        (clicked)="onShowCreateFolderControl()">
    </rpc-button>

</ng-template>